import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-latest-top-bar',
  templateUrl: './latest-top-bar.component.html',
  styleUrls: ['./latest-top-bar.component.css']
})
export class LatestTopBarComponent implements OnInit {


  public class = true;


  constructor() { }
  showMobileButton: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.showMobileButton = window.innerWidth <= 991;
  }

  ngOnInit(): void {
    this.showMobileButton = window.innerWidth <= 991;

  }
  
  ToggleMenuCustome() {
    if (this.class) {
      $("#bodySidebar").addClass("sidebar-icon-only");
      this.class = !this.class;
    } else {
      $("#bodySidebar").removeClass("sidebar-icon-only");
      this.class = !this.class;
    }
  }
  showMobileMenu() {
    $(".sidebar").toggleClass("active");
  }

}
